<template>
    <label class="block text-sm font-medium leading-6 text-gray-900 dark:text-white">
        <slot />
    </label>
</template>
